<template>
	<PageCrumbHeaderLayout class="one-on-one-page-crumb-header"
		:crumbs="crumbs"
		:disabled="disabled"
		v-on="bubble( `back`, `crumb` )"
	>
		<template #body>
			<slot name="body"></slot>
		</template>
	</PageCrumbHeaderLayout>
</template>

<script>
import { EventsMixin, PageCrumbHeaderLayout } from "@teaming/common-ui";
export default {
	name: "TeamPageCrumbHeader",
	mixins: [ EventsMixin, ],
	emits: [ "back", "crumb", ],
	components: {
		PageCrumbHeaderLayout,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { text:String, route:String, isActive:Boolean, }, ... ] */
		crumbs: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped></style>
